@if (rotatingEqWorkingFine()) {
  <div class="rotating-equipment">
    <div class="ga-sensor-health-fine detail-bold">
      <i
        nz-icon
        nzType="icons:status-check"
        class="mini-svg-icon fillgreen"
      ></i>
      <span>{{ i18n.langString("working_fine") }}</span>
    </div>
  </div>
}

@if (rotatingEqWarning()) {
  <div class="rotating-equipment">
    <div class="ga-sensor-health-check-warning detail-bold">
      <i
        nz-icon
        nzType="icons:status-exclamation-octagon"
        class="mini-svg-icon fillyellow"
      ></i>
      <span>{{ i18n.langString("warning") }}</span>
    </div>
  </div>
}

@if (rotatingEqCritical()) {
  <div class="rotating-equipment">
    <div class="ga-sensor-health-check detail-bold">
      <i
        nz-icon
        nzType="icons:status-exclamation-triangle"
        class="mini-svg-icon fillred"
      ></i>
      <span>{{ i18n.langString("critical") }}</span>
    </div>
  </div>
}

@if (rotatingEqInactive()) {
  <div class="rotating-equipment">
    <div class="ga-sensor-health-inactive detail-bold">
      <i
        nz-icon
        nzType="icons:cross-circle"
        class="mini-svg-icon fillblackcoral"
      ></i>
      <span>{{ i18n.langString("inactive") }}</span>
    </div>
  </div>
}
